var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, OnDestroy, OnInit, } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DurationEnum } from '@ats/models';
import { EventTrackerService } from '@commons/tracker/event-tracker/event-tracker.service';
import { Select, Store } from '@ngxs/store';
import { InitStaticData as InitApplicationStaticData, SetTmpApplication, } from '@store/applications/applications.actions';
import { CompaniesState } from '@store/companies/companies.state';
import { GetJob, InitStaticData as InitJobsStaticData } from '@store/jobs/jobs.actions';
import { JobsState } from '@store/jobs/jobs.state';
import { CandidateApplicationWebservice } from '@webservices/candidate-api/candidate-application.webservice';
import { ScrollToService } from '@wizbii/nicky-lenaers_ngx-scroll-to';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, distinctUntilChanged, finalize, first, map, shareReplay, switchMap, tap } from 'rxjs/operators';
// tslint:disable:relative-url-prefix
export class ApplyComponent {
    constructor(platformId, window, store, activatedRoute, candidateApplicationWebservice, cdr, scrollToService, eventTrackerService) {
        this.platformId = platformId;
        this.window = window;
        this.store = store;
        this.activatedRoute = activatedRoute;
        this.candidateApplicationWebservice = candidateApplicationWebservice;
        this.cdr = cdr;
        this.scrollToService = scrollToService;
        this.eventTrackerService = eventTrackerService;
        this.durationEnum = DurationEnum;
        this.send = false;
        this.loading = false;
        this.destroyed$ = new Subject();
        this.job$ = activatedRoute.paramMap.pipe(map(paramMap => paramMap.get('jobId')), distinctUntilChanged(), tap(jobId => store.dispatch(new GetJob(jobId))), switchMap(jobId => store.select(JobsState.job(jobId))), shareReplay());
    }
    ngOnInit() {
        this.store.dispatch(new InitJobsStaticData());
        this.store.dispatch(new InitApplicationStaticData());
    }
    ngAfterViewInit() {
        this.scrollToForm();
    }
    onSubmit({ form, jobId }) {
        if (form.invalid) {
            this.eventTrackerService.send({
                eventCategory: 'Home PreLaunch',
                eventAction: 'Form Status',
                eventLabel: [
                    !form.controls.firstname.valid ? 'firstname' : undefined,
                    !form.controls.lastname.valid ? 'lastname' : undefined,
                    !form.controls.email.valid ? 'email' : undefined,
                    !form.controls.phone.valid ? 'phone' : undefined,
                    !form.controls.presentation.valid ? 'presentation' : undefined,
                    !form.controls.cv.valid ? 'cv' : undefined,
                ]
                    .filter(error => !!error)
                    .join(','),
            });
            return;
        }
        this.loading = true;
        this.error = null;
        this.candidateApplicationWebservice
            .create(form, jobId)
            .pipe(first(), catchError(error => {
            this.error = error;
            this.cdr.markForCheck();
            return throwError(error);
        }), finalize(() => {
            this.loading = false;
            this.cdr.markForCheck();
        }))
            .subscribe(() => {
            this.send = true;
            this.cdr.markForCheck();
        });
    }
    scrollToForm() {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        this.window.setTimeout(() => {
            this.scrollToService.scrollTo({
                target: '#application-form',
                offset: 20,
            });
        }, 500);
    }
    trackByLabel(_, skill) {
        return skill;
    }
    ngOnDestroy() {
        this.store.dispatch(new SetTmpApplication(null));
        this.destroyed$.next();
        this.destroyed$.complete();
    }
}
__decorate([
    Select(CompaniesState.authenticatedCompany),
    __metadata("design:type", Observable)
], ApplyComponent.prototype, "company$", void 0);
